// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"ff38740c","726":"de113190","787":"aab7e903"}[chunkId] + ".chunk.js";
};